<template>
  <div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SubscriptionPaymentKnet',
  async created() {
    const payload = {
      amt: this.amount.kd,
      period: this.period,
    };
    const { data: { result } } = await this.$store.dispatch('payment/getKnetPaymentUrl', payload);
    window.open(result, '_self');
  },
  computed: {
    ...mapState('payment', ['amount', 'period']),
  },
};
</script>

<style scoped lang="less">

</style>
